// src/AudioSpectrum/effects/bars.js
import { getColor } from '../colorUtils.js';

export const drawBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 2, 128);
  const barWidth = width / barCount;
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const barHeight = (value / 255) * height;
    
    ctx.fillStyle = getColor(value);
    ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);
  }
};